/**
 * useStorage is a custom React hook that provides an interface for storing values on backend.
 *
 * It utilizes /api/conf/usrParam endpoint to persist user-specific parameters,
 * allowing them to be retained across sessions and devices.
 *
 * All API communication is handled by the data layer, which abstracts
 * away the details of making HTTP requests and managing state.
 */
import { useState } from "react";

import KeyValuePokkService from "#/data-layer/KeyValuePokkService";

export default function useRemoteStorage($key, defaultValue) {
  const svc = useMemo(
    () => new KeyValuePokkService({ baseUrl: "/api/conf/usrParam" }),
    []
  );

  const [item, setItem] = useState(defaultValue);

  // we are fairly limited here in what API allows us/expects, to use for the key
  // all uppercase, URL-safe characters...
  const key = $key.toUpperCase().replace(/[^A-Z0-9_]/g, "-");

  useEffect(() => {
    svc
      .get(key)
      .then(setItem)
      .catch((err) => {
        if (err?.status === 404) {
          // not found, do nothing...
          return;
        }

        throw err;
      });
  }, [key]);

  const persist = async (newValue) => {
    setItem(newValue);
    svc.put(key, newValue);
  };

  return [item, persist];
}
